
// countDown.vue
<template>
  <div class="count_down">
    <slot v-bind="{
      d: days, h: hours, m: mins, s: seconds,
      dd: `00${days}`.slice(-2),
      hh: `00${hours}`.slice(-2),
      mm: `00${mins}`.slice(-2),
      ss: `00${seconds}`.slice(-2),
    }"></slot>
  </div>
</template>
<script setup lang="ts">
import { computed, onMounted, ref, watch, type Ref } from 'vue'

const props = defineProps({
  time: {
    type: [Number, String],
    default: 0,
  },
  isMilliSecond: {
    type: Boolean,
    default: false,
  },
  end: {
    type: [Number, String],
    default: 0,
  },
})
const emits = defineEmits(['timeout'])

let curTime = 0

const days: Ref<string | number> = ref('0')

const hours: Ref<string | number> = ref('00')

const mins: Ref<string | number> = ref('00')

const seconds: Ref<string | number> = ref('00')

let timer: any = null

const remainingTime = computed(() => {
  if (props.end) {
    let end = props.isMilliSecond ? +props.end : +props.end * 1000

    end -= Date.now()
    return Math.round(end / 1000)
  }
  const time = props.isMilliSecond ? Math.round(+props.time / 1000) : Math.round(+props.time)

  return time
})

const countDown = () => {
  curTime = Date.now()
  countdown(remainingTime.value)
}

const formatTime = (time: number) => {
  const secondsInMinute = 60
  const secondsInHour = 24

  let t = time
  let ss = t % secondsInMinute

  t = (t - ss) / secondsInMinute

  const mm = t % secondsInMinute
  t = (t - mm) / secondsInMinute

  const hh = t % secondsInHour
  t = (t - hh) / secondsInHour

  const dd = t % secondsInHour

  return { dd, hh, mm, ss }
}

const countdown = (time: number) => {
  timer && clearTimeout(timer)

  if (time < 0) {
    emits('timeout')
    return
  }

  const { dd, hh, mm, ss } = formatTime(time)

  days.value = dd || 0
  hours.value = hh || 0
  mins.value = mm || 0
  seconds.value = ss || 0

  timer = setTimeout(() => {
    const now = Date.now()
    const diffTime = Math.floor((now - curTime) / 1000)

    const step = diffTime > 1 ? diffTime : 1 // 页面退到后台的时候不会计时，对比时间差，大于1s的重置倒计时

    curTime = now

    countdown(time - step)
  }, 1000)
}

watch(remainingTime, () => {
  countDown()
}, { immediate: true })

onMounted(() => {
  countDown()
})
</script>


